import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import Body from '../content/body';
import Sidebar from '../content/sidebar';

const PostDefault = props => {
  const { posts, advertorial } = props;
  const post = get(posts, '[0]', {});

  return (
    <div className="post post--default">
      <div className="post__main">
        <Body {...props} post={post} isLongPost={true} hasNewsletter={true} />
      </div>
      <Sidebar
        {...props}
        post={get(posts, '[0]')}
        fullPageAdvertorial={advertorial}
        isLongPost={true}
      />
    </div>
  );
};

PostDefault.propTypes = {
  posts: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  advertorial: PropTypes.bool.isRequired
};

export default PostDefault;
